import React from "react";

function Header() {
  return <h1>React sample text generator app</h1>;
}

export default Header;
